<template>
    <div>
        <p>
            This head of loss is calculated using the BC Legal General Damages PSLA Calculator.
                This assesses common law awards according to 'age' and 'duration' of symptoms-the period between onset
                of disease and death (or anticipated date of death).
        </p>
        <em>The relevant excerpt from the PLSA Calculator is shown below.</em>
        <table class="a-table a-table--full-width a-table--condensed u-margin-top-20">
            <thead>
            <tr>
                <th rowspan="2">Age (Up To)</th>
                <th colspan="3">Duration of Symptoms (months)</th>
            </tr>
            <tr>
                <th v-for="label in durationLabels">
                    {{label}}
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(row, ageKey) in tableResults">
                <th>{{ageLabels[ageKey]}}</th>
                <td v-for="(cell, cellIndex) in row"
                    :style="calcCellStyle(ageKey, cellIndex)">
                    {{currencyFormat(cell, "£", 0)}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import IconTooltip from 'components/IconTooltip.vue';
    import Heading from 'components/modal/Heading';
    import Paragraph from 'components/modal/Paragraph';
    import Modal from 'components/modal/Modal';
    import {mapActions} from 'vuex';
    import ModalInTheWild from "components/modal/ModalInTheWild";
    import currencyFormat from "mixins/currencyFormat";
    import AccordionItem from "components/accordion/AccordionItem";

    export default {
        name: "psla-modal-content",
        components: {
            AccordionItem,
            ModalInTheWild,
            Heading,
            Paragraph,
            IconTooltip,
            Modal
        },
        mixins: [
            currencyFormat
        ],
        props: {
            duration: {
                type: Number,
                required: true
            },
            age: {
                required: true
            },
            value: {
                required: true
            }
        },
        created() {
            this.init();
        },
        data() {
            return {
                table: {}
            }
        },
        computed: {
            tableResults() {
                if (!this.table[50]) {
                    return [];
                }
                let startRowIndex = (this.ageIndex <= 50) ? 50 :
                    (this.ageIndex > 80) ? 80 :
                        this.ageIndex - 5;

                let startColumnIndex = this.columnIndexStart;
                let endColumnIndex = this.columnIndexEnd;

                return [
                    this.table[startRowIndex].slice(startColumnIndex, endColumnIndex),
                    this.table[startRowIndex + 5].slice(startColumnIndex, endColumnIndex),
                    this.table[startRowIndex + 10].slice(startColumnIndex, endColumnIndex)
                ];
            },
            columnIndexStart() {
                if (this.durationIndex < 2) {
                    return 0;
                }
                if (this.durationIndex === 12) {
                    return this.durationIndex - 2;
                }
                return this.durationIndex - 1;
            },
            columnIndexEnd() {
                if (this.durationIndex === 0) {
                    return this.durationIndex + 3;
                }
                if (this.durationIndex === 12) {
                    return this.durationIndex + 1;
                }
                return this.durationIndex + 2;
            },
            ageIndex() {
                const age = parseFloat(this.age);
                if (age < 50) {
                    return 50;
                }
                if (age > 90) {
                    return 90;
                }
                return Math.ceil(age / 5) * 5;
            },
            ageLabels() {
                return (this.ageIndex < 60) ? [50, 55, 60] :
                    (this.ageIndex > 80) ? [80, 85, 90] :
                        [this.ageIndex - 5, this.ageIndex, this.ageIndex + 5];
            },
            durationIndex() {
                if (this.duration < 3) {
                    return 0;
                }
                if (this.duration > 36) {
                    return 12;
                }
                return Math.floor(this.duration / 3);
            },
            durationLabels() {
                return this.durationIndex < 2 ?
                    [
                        "0-3",
                        "4-6",
                        "7-9"
                    ] :
                    this.durationIndex > 9 ? [
                        "31-33",
                        "34-36",
                        "37+"
                    ] : [
                        ((this.durationIndex) * 3 - 2) + "-" + ((this.durationIndex) * 3),
                        ((this.durationIndex + 1) * 3 - 2) + "-" + ((this.durationIndex + 1) * 3),
                        ((this.durationIndex + 2) * 3 - 2) + "-" + ((this.durationIndex + 2) * 3)
                    ];
            }
        },
        methods: {
            ...mapActions('psla', ['loadTable']),
            ...mapActions('modal', ['toggle']),
            init() {
                this.loadTable()
                    .then((table) => this.table = table);
            },
            toggleThis() {
                this.toggle('day-one-res-psla');
            },
            calcCellStyle(rowIndex, cellIndex) {
                if (this.durationIndex === 0) {
                    if (rowIndex === 1 && cellIndex === 0) {
                        return 'background:#C5ECFE;font-weight:bold;';
                    }
                    if (rowIndex === 1 || cellIndex === 0) {
                        return 'background:#C5ECFE';
                    }
                }

                if (this.durationIndex === 12 && this.ageIndex <= 50) {
                    if (rowIndex === 0 && cellIndex === 2) {
                        return 'background:#C5ECFE;font-weight:bold;';
                    }
                    if (rowIndex === 0 || cellIndex === 2) {
                        return 'background:#C5ECFE';
                    }
                }

                if (this.durationIndex === 12 && this.ageIndex > 50 && this.ageIndex < 90) {
                    if (rowIndex === 1 && cellIndex === 2) {
                        return 'background:#C5ECFE;font-weight:bold;';
                    }
                    if (rowIndex === 1 || cellIndex === 2) {
                        return 'background:#C5ECFE';
                    }
                }

                if (this.durationIndex === 12 && this.ageIndex >= 90) {
                    if (rowIndex === 2 && cellIndex === 2) {
                        return 'background:#C5ECFE;font-weight:bold;';
                    }
                    if (rowIndex === 2 || cellIndex === 2) {
                        return 'background:#C5ECFE';
                    }
                }

                if (this.durationIndex > 0 && this.durationIndex < 12) {
                    if (rowIndex === 1 && cellIndex === 1) {
                        return 'background:#C5ECFE;font-weight:bold;';
                    }
                    if (rowIndex === 1 || cellIndex === 1) {
                        return 'background:#C5ECFE';
                    }
                }

                return ''
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PslaModalContent.vue?2964f033